import React from "react";
import { Col, Modal, Row } from "antd";

import Button from "../../FormElements/Button";
import Text from "../../Text";

const Basic = ({
  title = "Modal",
  description,
  open,
  closeable = true,
  className,
  onCancel,
  fontFamily,
  fontSize = 18,
  gutter = [0, 24],
  leftButtonText,
  rightButtonText,
  onClickLeft,
  onClickRight,
  loading,
  children,
  width,
  maskClosable,
  rootClassName
}) => {

  const handleClose = () => {
    onCancel()
  }

  return (
    <Modal
      classNames='p-0'
      open={open}
      className={className}
      onCancel={handleClose}
      closable={closeable}
      footer={null}
      width={width}
      centered
      maskClosable={maskClosable}
      destroyOnClose
      rootClassName={rootClassName}
    >
      <Row justify="center">
        {children ? children : (
          <>
            <Col span={24}>
              <Row justify="center">
                <Col>
                  <Text.Basic
                    fontFamily={fontFamily}
                    fontSize={fontSize}
                    text={title}
                  />
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row gutter={[0, 5]}>
                <Text.Basic
                  fontFamily={fontFamily}
                  fontSize={fontSize}
                  text={description}
                />
              </Row>
            </Col>
            <Col span={24}>
              <Row justify={"center"}>
                <Col>
                  <Button.Basic
                    text={leftButtonText}
                    onClick={onClickLeft}
                    size="large"
                  />
                </Col>
                <Col offset={1}>
                  <Button.Basic
                    type="primary"
                    size={"large"}
                    text={rightButtonText}
                    onClick={onClickRight}
                    disabled={loading}
                    isShowLoader={loading}
                  />
                </Col>
              </Row>
            </Col>
          </>
        )
        }
      </Row>
    </Modal>
  );
};
export default Basic;
